import React, { FC, useRef } from 'react';

import { PlayerView } from '@/scenarios/legacy-player/components/feature-player/ui/player-view/component';

import { UserActionIndicatorProvider } from '../../../feature-player/ui/skin/user-action-indicator/user-action-indicator-provider/component';

import styles from './ChannelPlayerView.module.css';
import { ChannelPlayerSkin } from './ChannelPlayerSkin';

interface ChannelPlayerViewProps {
    contentId: string;
    psid: string;
    withSkin?: boolean;
    onClose?: () => void;
}

export const ChannelPlayerView: FC<ChannelPlayerViewProps> = ({
    onClose = (): void => undefined,
    contentId,
    psid,
    withSkin = true,
}) => {
    const containerRef = useRef<HTMLDivElement>(null);

    return (
        <div ref={containerRef}>
            <PlayerView className={styles.root}>
                {withSkin ? (
                    <UserActionIndicatorProvider>
                        <ChannelPlayerSkin
                            contentId={contentId}
                            psid={psid}
                            className={styles.skin}
                            onClose={onClose}
                            rootContainerRef={containerRef}
                        />
                    </UserActionIndicatorProvider>
                ) : null}
            </PlayerView>
        </div>
    );
};
